// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"a5af56ac","124":"f096ccb7","296":"00cdcf7b","330":"a8103b4d","453":"4fbad7c7","501":"1ca094cf","656":"03c6a7e1","671":"46fe8afe","805":"551f5e4f","898":"636ab499","956":"fba4e809"}[chunkId] + ".chunk.js";
};